import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { CustomerApi, type UpdateCustomerDetailsRequest, type WithSignal } from '@shared/api';

const updateCustomerDetailsEffect = createEffect(({ signal, ...request }: WithSignal<UpdateCustomerDetailsRequest>) =>
  CustomerApi.updateCustomerDetails(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<boolean | null>(null)
  .on(updateCustomerDetailsEffect.done, (_, data) => data.result.success || false)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateCustomerDetailsEffect.pending, (_, data) => data)
  .on(updateCustomerDetailsEffect.fail, () => false)
  .on(updateCustomerDetailsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateCustomerDetailsEffect, () => null)
  .on(
    updateCustomerDetailsEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Customer Details. Please try again.').message,
  )
  .on(updateCustomerDetailsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $updateCustomerDetailsStore = {
  events: {
    updateCustomerDetails: updateCustomerDetailsEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
